import './splitPane.scss';
import * as React from 'react';
export const SplitPane = ({ left, right, alternate, leftProps: { className: leftClassName, ...leftAttr }, rightProps: { className: rightClassName, ...rightAttr }, className, vertical, darken, ...attr }) => (<div className={`split-pane${className ? ` ${className}` : ''}`} data-alternate={alternate} data-vertical={vertical} data-darken={darken} {...attr}>
    <div className="split-pane-inner">
      <div className={`split-pane-left${leftClassName ? ` ${leftClassName}` : ''}`} {...leftAttr}>
        {left}
      </div>
      <div className={`split-pane-right${rightClassName ? ` ${rightClassName}` : ''}`} {...rightAttr}>
        {right}
      </div>
    </div>
  </div>);
SplitPane.defaultProps = {
    leftProps: {},
    rightProps: {},
};
